import { isNullish } from '@y42/util/nullish';
import isEqual from 'lodash/isEqual';
import { areArraysEqual } from './are-arrays-equal';

export function haveEqualProps(
  objA: unknown,
  objB: unknown,
  props: string[],
  params: { propertyArrayOrderMatters: boolean } = { propertyArrayOrderMatters: false },
): boolean {
  if (isNullish(objA) && isNullish(objB)) {
    return true;
  }

  if (!!objA !== !!objB) {
    return false;
  }

  if (typeof objA !== 'object' || typeof objB !== 'object') {
    return objA === objB;
  }

  return props.every((prop) => {
    const propA = (objA as Record<string, unknown>)[prop];
    const propB = (objB as Record<string, unknown>)[prop];
    if (isNullish(propA) && isNullish(propB)) {
      return true;
    }

    if (Array.isArray(propA) && Array.isArray(propB)) {
      return areArraysEqual(propA, propB, { orderMatters: params.propertyArrayOrderMatters });
    }

    return isEqual(propA, propB);
  });
}
